import MyLearningCardComponent from '../../../../components/card/MyLearningCard.component'
import {LearningType} from '../../../../utils/enum'
import {IEnrolledCourse} from '../../../../interfaces'
import NoList from '../../../../components/empty-state/NoList.component'
import {useQuery} from '@apollo/client'
import {HASURA_ROLE_USER_CONTEXT, USER_ID} from '../../../../utils/globals'
import {GET_MY_COURSE} from '../../../../graphql/queries'
import Skeleton from 'react-loading-skeleton'
import {FC} from 'react'
import {TMyLearning} from '..'

const MyCourseComponent: FC<TMyLearning> = ({search, sort, filterData}) => {
  let orderBy

  switch (sort) {
    case 'oldest':
      orderBy = {
        date_added: 'asc',
      }
      break
    case 'nameASC':
      orderBy = {
        title: 'asc',
      }
      break
    case 'nameDESC':
      orderBy = {
        title: 'desc',
      }
      break
    default:
      orderBy = {
        date_added: 'desc',
      }
  }

  const _filter: any = filterData

  const filterLanguage = _filter.language?.map((res: number) => res.toString())

  const {data, loading} = useQuery(GET_MY_COURSE, {
    variables: {
      userId: USER_ID,
      search: `%${search}%`,
      orderBy: [orderBy],
      ...filterData,
      language: filterLanguage,
    },
    ...HASURA_ROLE_USER_CONTEXT,
  })

  const isSearching = search || Object.keys(filterData).length > 0

  if (loading) {
    return (
      <>
        {Array.from({length: 2}).map((res, i) => (
          <Skeleton height="140px" className="mb-4" key={i} />
        ))}
      </>
    )
  }

  return (
    <>
      {data.academy_courses.length === 0 ? (
        <NoList
          imageSize={180}
          title={
            isSearching
              ? 'Tidak ada hasil yang ditemukan'
              : 'Maaf, tidak ada daftar'
          }
          subTitle={
            isSearching
              ? 'Sepertinya kami tidak dapat menemukan hasil apa pun berdasarkan pencarian Anda'
              : 'Saat ini Anda tidak memiliki kursus'
          }
        />
      ) : (
        data.academy_courses.map((val: IEnrolledCourse) => {
          return (
            <MyLearningCardComponent
              key={val.id}
              data={val}
              type={LearningType.COURSE}
            />
          )
        })
      )}
    </>
  )
}

export default MyCourseComponent
